/* Imports needed for all question form subclasses. */
import * as React from 'react';
import { connect } from 'react-redux';
import {
    QuestionFormBase,
    QuestionFormBaseProps,
    QuestionFormBaseState,
    mapStateToQuestionFormBaseProps,
    mapDispatchToQuestionFormBaseProps
} from '../../QuestionFormBase';
import * as _ from 'lodash';
import {
    ConversationalSettings,
    MAX_DEMERIT_POINTS_VALUES,
    QTYPES
} from '@nexxt/common/types';
import NotifyHOC from '../../../../../../HOC/Notifications';

/* Components used in this question form. */
import BuilderHeader from '../../../common/builderHeader';
import QuestionSettings from '../../../common/questionSettings';

/* Imports specifically for open-end question form. */
import ValidationOptionField from '../../../common/validationOptionField';
import MultimediaBubble from '../../../common/MultimediaBubble';

type Props = QuestionFormBaseProps;

interface States extends QuestionFormBaseState {
    conversationalSettings: ConversationalSettings;
}

class FormOpenEnded extends QuestionFormBase<Props, States> {
    constructor(p: QuestionFormBaseProps) {
        super(p, QTYPES.OPEN);
        const { isNewQuestion, currentProject } = this.props;
        const languages = currentProject.languages;
        const question = {
            ...this.state.question,
            lazyAnswer: isNewQuestion ? false : this.state.question.lazyAnswer,
            gibberish: isNewQuestion ? false : this.state.question.gibberish,
            allowUserEdit: true,
            conversationalSettings:
                isNewQuestion ||
                JSON.stringify(this.state.question.conversationalSettings) ===
                    '{}'
                    ? {
                          qualityControlSettings: {
                              enableCheckDemeritAi: false,
                              enableCheckDemeritDuplicate: false,
                              enableCheckDemeritGibberish: Boolean(
                                  this.state.question.gibberish
                              ),
                              enableCheckDemeritUninformative: Boolean(
                                  this.state.question.lazyAnswer
                              ),
                              maxDemeritPoints: MAX_DEMERIT_POINTS_VALUES.NORMAL
                          },
                          smartProbeSettings: {
                              enableSmartProbe: Boolean(
                                  this.state.question.showGenericProbe
                              ),
                              enableTargets: false,
                              enableResearchContext: false,
                              enableTrainedModels: false
                          }
                      }
                    : this.state.question.conversationalSettings
        };
        this.state = {
            ...this.state,
            question
        };
    }

    render() {
        const { currentProject } = this.props;
        const { question, isSettingBoxLayoutOpen } = this.state;
        const questionError =
            (this.state.showError && this.state.questionError) || {};
        return (
            <div>
                <div className="project-add--question-builder">
                    <BuilderHeader
                        toggleSettingBoxLayout={this.toggleSettingBoxLayout}
                        isSettingBoxLayoutOpen={isSettingBoxLayoutOpen}
                        showAlert={!this.props.editEnabled}
                        alertMessages={this.getWarningMessage()}
                        question={question}
                        disabled={!this.props.editEnabled}
                        setValue={this.setQuestion}
                        errorObject={this.state.questionError}
                    />
                    <div className="builder-body">
                        {(isSettingBoxLayoutOpen && (
                            <QuestionSettings
                                onClose={this.toggleSettingBoxLayout}
                                question={question}
                                questionSettings={{
                                    allowUserEdit: true,
                                    showQualityControl: true,
                                    allowCopyPaste: true,
                                    showValidation: true,
                                    showGenericProbe: true
                                }}
                                disableQuestionSettings={{
                                    allowUserEdit: true
                                }}
                                setValue={this.setQuestion}
                                disabled={!this.props.editEnabled}
                            />
                        )) ||
                            null}
                        {this.renderErrorNotes()}
                        <MultimediaBubble
                            question={question}
                            languages={currentProject.languages}
                            setValue={this.setQuestion}
                            setValueWithLanguage={
                                this.NEW_setQuestionTextTranslation
                            }
                            addNewBubble={this.NEW_addNewEditor}
                            removeBubble={this.NEW_removeEditor}
                            disabled={!this.props.editEnabled}
                            questionError={questionError}
                            settings={{ showClose: true }}
                        />

                        {this.state.question.showValidation && (
                            <ValidationOptionField
                                question={question}
                                questionError={questionError}
                                setValue={this.setQuestion}
                                disabled={!this.props.editEnabled}
                            />
                        )}
                    </div>
                    {/* end of builder-body*/}
                </div>
            </div>
        );
    }
}

export default NotifyHOC(
    connect(
        mapStateToQuestionFormBaseProps,
        mapDispatchToQuestionFormBaseProps
    )(FormOpenEnded)
);
